import React, { Component } from "react";

import { Translate, I18n } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";

import { compressImage } from "../../utils/Utils";

import "../../../styles/components/chargers/modals/ActionInfrastructure.scss";
import camera from "../../../styles/images/camera.svg";
import station from "../../../styles/images/station.svg";

class EditGroup extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      picture: station,
      name: "",
    };

    this.handlePickPicture = this.handlePickPicture.bind(this);
    this.handlePictureChange = this.handlePictureChange.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.hasOwnProperty("selectedGroup") && this.props.selectedGroup)
      if (
        prevProps.selectedGroup !== this.props.selectedGroup ||
        prevProps.selectedGroup._id !== this.props.selectedGroup._id
      )
        this.safeSetState({
          picture: this.props.selectedGroup.imageContent + "?v=" + Date.now(),
          name: this.props.selectedGroup.name,
        });
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handlePickPicture(e) {
    document.getElementById("file-picker").click();
  }

  handlePictureChange(e) {
    let file = e.target.files && e.target.files[0];

    compressImage(file).then(picture => {
      this.safeSetState({ picture });
    });
  }

  handleOnChange(e) {
    this.safeSetState({
      [e.target.name]: e.target.value,
    });
  }

  resetState(){
    this.safeSetState({
      picture: station,
      name: "",
    })
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <>
        <Modal id="editInfrastructure" show={this.props.show} onHide={this.props.onHide} onExited={this.resetState.bind(this)} centered>
          <Modal.Header>
            <Modal.Title>
              <Translate value="myChargers_editChargerPlace" />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="picture-picker-container">
              <input
                id="file-picker"
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={this.handlePictureChange}
              />
              <button type="button" className="picture-picker" onClick={this.handlePickPicture}>
                <img id="picture" src={this.state.picture || station} alt="" />
                <img src={camera} className="camera" alt="" />
              </button>
            </div>
            <form
              id="edit-infrastructure-form"
              onSubmit={e => this.props.onSubmit(e, this.state.picture)}
            >
              <div className="form-field">
                <p>
                  <Translate value="myChargersAddInfr_name" />
                </p>
                <input
                  type="text"
                  name="name"
                  placeholder={I18n.t("myChargersAddInfr_exHome")}
                  value={this.state.name}
                  onChange={this.handleOnChange}
                />
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button type="submit" form="edit-infrastructure-form">
              <Translate value="myChargers_editChargerPlace" />
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default EditGroup;
